import './Spinner.css';

const Spinner = () => {

	return(
	<div className='full-screen'>
		<div className='portal-item'>
		<div className='portal-loading bar'>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
		</div>
	</div>);

};

export default Spinner;
